import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import MembersSidebar from '../components/MembersSidebar';
import { Download } from 'lucide-react';

const API_BASE_URL = "https://backend.dlapakistan.com/api";

const MembersDownloads = () => {
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingId, setDownloadingId] = useState(null);

  const GREEN = "#70B444";

  useEffect(() => {
    const token = localStorage.getItem('member_token');
    const memberData = localStorage.getItem('member_data');
    
    if (!token || !memberData) {
      navigate('/members/members-area');
      return;
    }
    
    try {
      const parsedMember = JSON.parse(memberData);
      setMember(parsedMember);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchDownloads();
    } catch (error) {
      console.error("Error:", error);
    }
  }, []);

  const fetchDownloads = async () => {
    try {
      setLoading(true);
      console.log("📦 Fetching downloads...");
      
      const response = await axios.get(`${API_BASE_URL}/dla-shop/basket/member_orders/`);
      
      console.log("📦 Response:", response.data);
      
      if (response.data?.success) {
        const orders = response.data.orders || [];
        const items = [];
        
        orders.forEach(order => {
          if (order.files && order.files.length > 0) {
            order.files.forEach(file => {
              items.push({
                id: file.id,
                file_name: file.file_name,
                file_url: file.file_url,
                product_name: order.product_title,
                downloaded_at: order.ordered_at
              });
            });
          }
        });
        
        console.log(`✅ Found ${items.length} files`);
        setDownloads(items);
      }
    } catch (error) {
      console.error("❌ Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (item) => {
    setDownloadingId(item.id);
    
    try {
      let fileUrl = item.file_url;
      if (fileUrl?.startsWith('/')) {
        fileUrl = `${API_BASE_URL}${fileUrl}`;
      }
      
      const token = localStorage.getItem('member_token');
      const response = await fetch(fileUrl, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = item.file_name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setDownloadingId(null);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  if (!member) {
    return (
      <Container fluid className="py-5 mt-40" style={{ maxWidth: '95%' }}>
        <div className="text-center py-5">Loading...</div>
      </Container>
    );
  }

  return (
    <Container fluid className="py-5 mt-40" style={{ maxWidth: '95%' }}>
      <div className="mb-4">
        <h1 className="h3 mb-3">
          Hello {member.first_name} {member.last_name}
        </h1>
        <p className="text-muted">My Downloads</p>
      </div>

      <Row>
        <Col lg={3} md={4}>
          <MembersSidebar />
        </Col>

        <Col lg={9} md={8}>
          <div className="bg-white p-4 rounded shadow-sm">
            <h4 className="mb-4" style={{ color: GREEN }}>Download History</h4>
            
            {loading ? (
              <div className="text-center py-4">Loading downloads...</div>
            ) : downloads.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted mb-3">No downloads yet</p>
                <Button 
                  variant="success" 
                  onClick={() => navigate('/dlashop')}
                  style={{ backgroundColor: GREEN, borderColor: GREEN }}
                >
                  Browse Products
                </Button>
              </div>
            ) : (
              <Table hover responsive className="align-middle">
                <thead>
                  <tr>
                    <th>File Name</th>
                    <th>Product</th>
                    <th>Downloaded On</th>
                    <th style={{ width: '80px' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {downloads.map((item) => (
                    <tr key={item.id}>
                      <td className="fw-medium">{item.file_name}</td>
                      <td>{item.product_name}</td>
                      <td className="text-muted small">{formatDate(item.downloaded_at)}</td>
                      <td>
                        <Button
                          variant="link"
                          onClick={() => handleDownload(item)}
                          disabled={downloadingId === item.id}
                          className="p-0"
                          style={{ color: GREEN }}
                        >
                          {downloadingId === item.id ? (
                            <span className="spinner-border spinner-border-sm" style={{ color: GREEN }} />
                          ) : (
                            <Download size={18} />
                          )}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MembersDownloads;